import axios from "axios";
import { baseUrl } from "./apiBase";

const getUserInfo = (token) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/getUserInfo?new=New`,

    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getActiveMonitoringSessions = (entityId) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/getActiveMonitoringSessions?getEntityId=${entityId}`,

    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};
const getActiveMonitoringSessionBySubjectId = (
  entityId,
  subjectId,
  getEntityId,
) => {
  const getEntityIdParam = getEntityId ? `&getEntityId=${getEntityId}` : "";
  const config = {
    method: "GET",
    url: `${baseUrl}/getActiveMonitoringSessionBySubjectId?entityId=${entityId}&subjectId=${subjectId}${getEntityIdParam}`,

    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};

const getActiveMonitoringSessionsBySubscription = (
  entityId,
  connectionType,
  entityName,
) => {
  const entityNameQueryParam = entityName ? `&entityName=${entityName}` : "";

  const config = {
    method: "GET",
    url: `${baseUrl}/getActiveMonitoringSessionsBySubscription?entityId=${entityId}&connectionType=${connectionType}${entityNameQueryParam}`,
    timeout: 30000,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};
const negotiate = () => {
  const config = {
    method: "POST",
    url: `${baseUrl}/negotiate`,

    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};
const joinSignalRGroups = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/joinSignalRGroups`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const removeSignalRGroups = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/removeSignalRGroups`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getEntityRouters = (entityId) => {
  const entityIdParam = entityId ? `&getEntityId=${entityId}` : "";
  const config = {
    method: "GET",
    url: `${baseUrl}/getEntityRouters?web=Web${entityIdParam}`,

    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};
const getImageSasToken = (getEntityId) => {
  const getEntityIdParam = getEntityId ? `?getEntityId=${getEntityId}` : "";

  const config = {
    method: "GET",
    url: `${baseUrl}/getImageSasToken${getEntityIdParam}`,

    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};
const stopMonitoringSession = (payload, token) => {
  payload.deviceType = "Web App";

  const config = {
    method: "POST",
    url: `${baseUrl}/stopMonitoringSession`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const resetCriticalAlert = (payload, token) => {
  payload.deviceType = "Web App";

  const config = {
    method: "POST",
    url: `${baseUrl}/resetCriticalAlert`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getArchiveData = (
  subjectId,
  startTime,
  endTime,
  token,
  defaultBiometricsThresholds,
  getEntityId,
) => {
  const defaultBiometricsThresholdsQueryParam = defaultBiometricsThresholds
    ? `&defaultBiometricsThresholds=${defaultBiometricsThresholds}`
    : "";
  const getEntityIdParam = getEntityId ? `&getEntityId=${getEntityId}` : "";
  const config = {
    method: "GET",
    url: `${baseUrl}/getArchiveData?subjectId=${subjectId}&startTime=${startTime}&endTime=${endTime}${defaultBiometricsThresholdsQueryParam}${getEntityIdParam}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getSubjectBatteryHistory = (
  subjectId,
  startTime,
  endTime,
  token,
  getEntityId,
) => {
  const params = new URLSearchParams();
  params.append("subjectId", subjectId);
  params.append("startTime", startTime);
  params.append("endTime", endTime);
  if (getEntityId) {
    params.append("getEntityId", getEntityId);
  }
  const config = {
    method: "GET",
    url: `${baseUrl}/getSubjectBatteryHistory?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getDeviceSessionHistory = (
  deviceId,
  token,
  limit,
  { includeSubjects } = {},
) => {
  const params = new URLSearchParams();
  params.append("deviceId", deviceId);
  if (limit) {
    params.append("limit", limit.toString());
  }
  if (includeSubjects === true) {
    params.append("includeSubjects", "true");
  }
  const config = {
    method: "GET",
    url: `${baseUrl}/getDeviceSessionHistory?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getEntityUsers = (entityId, pageSize, pageNumber, token, entityName) => {
  const entityNameQueryParam = entityName ? `&entityName=${entityName}` : "";
  const entityIdParam = entityId ? `&getEntityId=${entityId}` : "";

  const config = {
    method: "GET",
    url: `${baseUrl}/getEntityUsers?pageSize=${pageSize}&pageNumber=${pageNumber}${entityNameQueryParam}${entityIdParam}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getEntityUsersBySearch = (
  entityId,
  pageSize,
  pageNumber,
  search,
  token,
  entityName,
) => {
  const entityNameQueryParam = entityName ? `&entityName=${entityName}` : "";
  const entityIdParam = entityId ? `&getEntityId=${entityId}` : "";

  const config = {
    method: "GET",
    url: `${baseUrl}/getEntityUsersBySearch?pageSize=${pageSize}&pageNumber=${pageNumber}&search=${search}${entityNameQueryParam}${entityIdParam}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getEntityUsersV2 = (
  entityId,
  pageSize,
  continuationToken,
  token,
  entityName,
  sortBy,
  sortDir,
) => {
  const params = new URLSearchParams();
  params.append("pageSize", pageSize.toString());
  if (continuationToken) {
    params.append("continuationToken", continuationToken);
  }
  if (entityName) {
    params.append("entityName", entityName);
  }
  if (entityId) {
    params.append("getEntityId", entityId);
  }
  if (sortBy) {
    params.append("sortBy", sortBy);
  }
  if (sortDir) {
    params.append("sortDir", sortDir);
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getEntityUsersV2?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getEntityUsersBySearchV2 = (
  entityId,
  pageSize,
  continuationToken,
  search,
  token,
  entityName,
  sortBy,
  sortDir,
) => {
  const params = new URLSearchParams();
  params.append("pageSize", pageSize.toString());
  params.append("search", search);
  if (continuationToken) {
    params.append("continuationToken", continuationToken);
  }
  if (entityName) {
    params.append("entityName", entityName);
  }
  if (entityId) {
    params.append("getEntityId", entityId);
  }
  if (sortBy) {
    params.append("sortBy", sortBy);
  }
  if (sortDir) {
    params.append("sortDir", sortDir);
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getEntityUsersBySearchV2?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const inviteUser = (payload) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/inviteUser`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};

const changeUsersRole = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/changeUsersRole`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const pinSubject = (payload, token) => {
  payload.deviceType = "Web App";

  const config = {
    method: "POST",
    url: `${baseUrl}/pinSubject`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const unpinSubject = (payload, token) => {
  payload.deviceType = "Web App";
  const config = {
    method: "POST",
    url: `${baseUrl}/unpinSubject`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getAlertHistoryV2 = (
  subjectId,
  pageSize,
  continuationToken,
  transferredFrom,
  token,
  getEntityId,
) => {
  const params = new URLSearchParams();

  params.append("subjectId", subjectId);
  params.append("pageSize", pageSize.toString());

  if (continuationToken) {
    params.append("continuationToken", continuationToken);
  }

  if (transferredFrom) {
    params.append("transferredFrom", JSON.stringify(transferredFrom));
  }

  if (getEntityId) {
    params.append("getEntityId", getEntityId);
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getAlertHistoryV2?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  return axios(config);
};

const updateUserPreference = (payload, token) => {
  if (payload.userLocationSubscription) {
    payload.deviceType = "Web App";
  }

  const config = {
    method: "POST",
    url: `${baseUrl}/updateUserPreference`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getEntitySubjectsByPagination = (
  entityId,
  pageSize,
  pageNumber,
  token,
  entityName,
  getEntityId,
) => {
  const entityNameQueryParam = entityName ? `&entityName=${entityName}` : "";
  const getEntityIdParam = getEntityId ? `&getEntityId=${getEntityId}` : "";
  const config = {
    method: "GET",
    url: `${baseUrl}/getEntitySubjectsByPagination?entityId=${entityId}&pageSize=${pageSize}&pageNumber=${pageNumber}${entityNameQueryParam}${getEntityIdParam}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getEntitySubjectsBySearchPagination = (
  entityId,
  pageSize,
  pageNumber,
  search,
  token,
  entityName,
  getEntityId,
) => {
  const entityNameQueryParam = entityName ? `&entityName=${entityName}` : "";
  const getEntityIdParam = getEntityId ? `&getEntityId=${getEntityId}` : "";

  const config = {
    method: "GET",
    url: `${baseUrl}/getEntitySubjectsBySearchPagination?entityId=${entityId}&pageSize=${pageSize}&pageNumber=${pageNumber}&search=${search}${entityNameQueryParam}${getEntityIdParam}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getSubjectsProfile = (entityId, subjectId, token, getEntityId) => {
  const getEntityIdParam = getEntityId ? `&getEntityId=${getEntityId}` : "";
  const config = {
    method: "GET",
    url: `${baseUrl}/getSubjectsProfile?entityId=${entityId}&subjectId=${subjectId}${getEntityIdParam}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getPdfSasLink = (entityId, subjectId, date, token, getEntityId) => {
  const getEntityIdParam = getEntityId ? `&getEntityId=${getEntityId}` : "";
  const config = {
    method: "GET",
    url: `${baseUrl}/getPdfSasLink?entityId=${entityId}&subjectId=${subjectId}&date=${date}${getEntityIdParam}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getEntitiesByPagination = (pageNumber, pageSize, token) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/getEntitiesByPagination?pageNumber=${pageNumber}&pageSize=${pageSize}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getEntitiesBySearchPagination = (pageNumber, pageSize, search, token) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/getEntitiesBySearchPagination?pageNumber=${pageNumber}&pageSize=${pageSize}&search=${search}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getEntitiesV2 = (
  pageSize,
  continuationToken,
  search,
  token,
  entityId,
) => {
  const params = new URLSearchParams();
  params.append("pageSize", pageSize.toString());

  if (continuationToken) {
    params.append("continuationToken", continuationToken);
  }

  if (search) {
    params.append("search", search);
  }

  if (entityId) {
    params.append("entityId", entityId);
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getEntitiesV2?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const checkDeviceData = (deviceId, subjectId, minutesAgo, token) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/checkDeviceData?deviceId=${deviceId}&subjectId=${subjectId}&minutesAgo=${minutesAgo}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const createEntity = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/createEntity`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getEntitysInformation = (entityId) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/getEntitysInformation?getEntityId=${entityId}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};

const registerRouter = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/registerRouter`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const removeUsersNfcTools = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/removeUsersNfcTools`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const addUsersNfcTools = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/addUsersNfcTools`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getSubjectsInteractionHistoryByPagination = (
  subjectId,
  pageSize,
  pageNumber,
  token,
) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/getSubjectsInteractionHistoryByPagination?subjectId=${subjectId}&pageSize=${pageSize}&pageNumber=${pageNumber}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const logUsersAlertAction = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/logUsersAlertAction`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const logSubjectNote = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/logSubjectNote`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const publicDataProcessor = (payload, token) => {
  const config = {
    method: "POST",
    url: "https://api.4sightlabs.com/publicDataShare/publicDataProcessor",
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const joinSignalRGroupsV2 = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/joinSignalRGroupsV2`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const removeSignalRGroupsV2 = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/removeSignalRGroupsV2`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const changeUsersTitle = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/changeUsersTitle`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const changeGatewayLocation = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/changeGatewayLocation`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getCheckedOutSensors = (
  entityId,
  pageSize,
  pageNumber,
  token,
  entityName,
) => {
  const entityNameQueryParam = entityName ? `&entityName=${entityName}` : "";

  const config = {
    method: "GET",
    url: `${baseUrl}/getCheckedOutSensors?entityId=${entityId}&pageSize=${pageSize}&pageNumber=${pageNumber}${entityNameQueryParam}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getCheckedOutSensorsBySearch = (
  entityId,
  pageSize,
  pageNumber,
  search,
  token,
  entityName,
) => {
  const entityNameQueryParam = entityName ? `&entityName=${entityName}` : "";

  const config = {
    method: "GET",
    url: `${baseUrl}/getCheckedOutSensorsBySearch?entityId=${entityId}&pageSize=${pageSize}&pageNumber=${pageNumber}&search=${search}${entityNameQueryParam}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getUsersData = (userId, token, getEntityId) => {
  const getEntityIdParam = getEntityId ? `&getEntityId=${getEntityId}` : "";

  const config = {
    method: "GET",
    url: `${baseUrl}/getUsersData?userId=${userId}${getEntityIdParam}`,

    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const createFakeUser = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/createFakeUser`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const updateEntityLogo = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/updateEntityLogo`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const deleteUser = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/deleteUser`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const logWellnessRecord = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/logWellnessRecord`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const logSignalRDisconnect = (payload) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/logSignalRDisconnect`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};
const getHourlyWellnessData = (
  subjectId,
  entityId,
  transferredFrom,
  token,
  getEntityId,
) => {
  const doestransferredFromExist = transferredFrom
    ? `&transferredFrom=${encodeURIComponent(JSON.stringify(transferredFrom))}`
    : "";

  const getEntityIdParam = getEntityId ? `&getEntityId=${getEntityId}` : "";
  const config = {
    method: "GET",
    url: `${baseUrl}/getHourlyWellnessData?subjectId=${subjectId}&entityId=${entityId}${doestransferredFromExist}${getEntityIdParam}`,

    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getDailyWellnessData = (
  subjectId,
  entityId,
  transferredFrom,
  token,
  getEntityId,
) => {
  const doestransferredFromExist = transferredFrom
    ? `&transferredFrom=${encodeURIComponent(JSON.stringify(transferredFrom))}`
    : "";
  const getEntityIdParam = getEntityId ? `&getEntityId=${getEntityId}` : "";
  const config = {
    method: "GET",
    url: `${baseUrl}/getDailyWellnessData?subjectId=${subjectId}&entityId=${entityId}${doestransferredFromExist}${getEntityIdParam}`,

    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getDailyWellnessDataByPaginationV2 = (
  subjectId,
  entityId,
  pageSize,
  continuationToken,
  transferredFrom,
  token,
  getEntityId,
) => {
  const params = new URLSearchParams();

  params.append("subjectId", subjectId);
  params.append("entityId", entityId);
  params.append("pageSize", pageSize.toString());

  if (continuationToken) {
    params.append("continuationToken", continuationToken);
  }

  if (transferredFrom) {
    params.append("transferredFrom", JSON.stringify(transferredFrom));
  }

  if (getEntityId) {
    params.append("getEntityId", getEntityId);
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getDailyWellnessDataByPaginationV2?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getHourlyWellnessDataByPaginationV2 = (
  subjectId,
  entityId,
  pageSize,
  continuationToken,
  transferredFrom,
  token,
  getEntityId,
) => {
  const params = new URLSearchParams();

  params.append("subjectId", subjectId);
  params.append("entityId", entityId);
  params.append("pageSize", pageSize.toString());

  if (continuationToken) {
    params.append("continuationToken", continuationToken);
  }

  if (transferredFrom) {
    params.append("transferredFrom", JSON.stringify(transferredFrom));
  }

  if (getEntityId) {
    params.append("getEntityId", getEntityId);
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getHourlyWellnessDataByPaginationV2?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getMinutelyWellnessDataByPaginationV2 = (
  subjectId,
  entityId,
  pageSize,
  continuationToken,
  defaultBiometricsThresholds,
  transferredFrom,
  token,
  getEntityId,
) => {
  const params = new URLSearchParams();

  params.append("subjectId", subjectId);
  params.append("entityId", entityId);
  params.append("pageSize", pageSize.toString());
  params.append("defaultBiometricsThresholds", defaultBiometricsThresholds);

  if (continuationToken) {
    params.append("continuationToken", continuationToken);
  }

  if (transferredFrom) {
    params.append("transferredFrom", JSON.stringify(transferredFrom));
  }

  if (getEntityId) {
    params.append("getEntityId", getEntityId);
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getMinutelyWellnessDataByPaginationV2?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const createInstantCriticalAlert = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/createInstantCriticalAlert`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const reportGeneratorHTTP = (payload, token) => {
  const config = {
    method: "POST",
    url: `https://api.4sightlabs.com/publicDataShare/reportGeneratorHTTP`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getDataForDownloadPdfSasLink = (filePath, token) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/getDataForDownloadPdfSasLink?filePath=${filePath}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getTrainingMaterials = (token) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/listTrainingMaterials`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getTrainingMaterialSasLink = (materialId, token) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/getTrainingMaterialSasLink?materialId=${encodeURIComponent(
      materialId,
    )}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const updateTrainingProgress = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/updateTrainingProgress`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getTrainingUploadSasLink = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/getTrainingUploadSasLink`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const createTrainingMaterial = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/createTrainingMaterial`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const updateTrainingMaterial = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/updateTrainingMaterial`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const deleteTrainingMaterial = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/deleteTrainingMaterial`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

// Direct-to-blob upload via a write SAS. Uses a clean axios instance so the
// global auth interceptor never attaches a Bearer token to the storage call.
const uploadFileToTrainingSas = (uploadUrl, file, onProgress) => {
  const instance = axios.create();
  return instance.put(uploadUrl, file, {
    headers: {
      "x-ms-blob-type": "BlockBlob",
      "Content-Type": file.type || "application/octet-stream",
    },
    onUploadProgress: (event) => {
      if (onProgress && event.total) {
        onProgress(Math.round((event.loaded / event.total) * 100));
      }
    },
  });
};

const getAnalyticsData = (entityId, getEntityId) => {
  const getEntityIdParam = getEntityId ? `&getEntityId=${getEntityId}` : "";

  const config = {
    method: "GET",
    url: `${baseUrl}/getAnalyticsData?entityId=${entityId}${getEntityIdParam}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};
const createFeedback = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/createFeedback`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
const getSuperAnalyticsData = (token) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/getSuperAnalyticsData`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const transferSubjects = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/transferSubjects`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const createAlertGroup = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/createAlertGroup`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const deleteAlertGroup = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/deleteAlertGroup`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const addSubjectsToAlertGroup = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/addSubjectsToAlertGroup`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const removeSubjectsFromAlertGroup = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/removeSubjectsFromAlertGroup`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const createAcknowledgeDeviceNotification = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/createAcknowledgeDeviceNotification`,
    data: payload,
    timeout: 15000,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const createGeneralFeedback = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/createGeneralFeedback`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const createCellSubject = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/createCellSubject`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const createSubject = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/createSubject`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const editSubject = (payload, token) => {
  payload.deviceType = "Web App";
  const config = {
    method: "POST",
    url: `${baseUrl}/editSubject`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getEntityActiveSubjectsByPagination = (
  entityId,
  pageSize,
  pageNumber,
  token,
  entityName,
) => {
  const entityNameQueryParam = entityName ? `&entityName=${entityName}` : "";
  const config = {
    method: "GET",
    url: `${baseUrl}/getEntityActiveSubjectsByPagination?entityId=${entityId}&pageSize=${pageSize}&pageNumber=${pageNumber}${entityNameQueryParam}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getEntityActiveSubjectsBySearchPagination = (
  entityId,
  pageSize,
  pageNumber,
  search,
  token,
  entityName,
) => {
  const entityNameQueryParam = entityName ? `&entityName=${entityName}` : "";
  const config = {
    method: "GET",
    url: `${baseUrl}/getEntityActiveSubjectsBySearchPagination?entityId=${entityId}&pageSize=${pageSize}&pageNumber=${pageNumber}&search=${search}${entityNameQueryParam}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const deleteSubject = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/deleteSubject`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const deleteRouter = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/deleteRouter`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const updateUserInformation = (payload) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/updateUserInformation`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};

const updateEntityInformation = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/updateEntityInformation`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

// Critical-alert callbacks (4SightAdmin only). The parameter names getEntityId
// and updateEntityId are NOT cosmetic — APIM authorizes the caller against
// them, so renaming either one silently drops the tenant check.
const getEntityCallbacks = (entityId, token) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/getEntityCallbacks?getEntityId=${encodeURIComponent(entityId)}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const updateEntityCallbacks = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/updateEntityCallbacks`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getOptiGuardAlertSubscriptions = (entityId, token) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/getOptiGuardAlertSubscriptions?getEntityId=${encodeURIComponent(entityId)}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const updateOptiGuardAlertSubscription = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/updateOptiGuardAlertSubscription`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getUserActionsHistoryV2 = (
  subjectId,
  entityId,
  pageSize,
  continuationToken,
  transferredFrom,
  token,
  getEntityId,
) => {
  const params = new URLSearchParams();

  params.append("subjectId", subjectId);
  params.append("entityId", entityId);
  params.append("pageSize", pageSize.toString());

  if (continuationToken) {
    params.append("continuationToken", continuationToken);
  }

  if (transferredFrom) {
    params.append("transferredFrom", JSON.stringify(transferredFrom));
  }

  if (getEntityId) {
    params.append("getEntityId", getEntityId);
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getUserActionsHistoryV2?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  return axios(config);
};

const getSupportInbox = (payload, token) => {
  const {
    pageSize,
    continuationToken,
    getEntityId,
    eventTypeFilter,
    fromTimestamp,
    toTimestamp,
    countOnly,
    groupByEntity,
  } = payload || {};

  const params = new URLSearchParams();

  if (countOnly) {
    params.append("countOnly", "true");
  }

  if (groupByEntity) {
    params.append("groupByEntity", "true");
  }

  if (pageSize !== undefined) {
    params.append("pageSize", pageSize.toString());
  }

  if (continuationToken) {
    params.append("continuationToken", continuationToken);
  }

  if (getEntityId) {
    params.append("getEntityId", getEntityId);
  }

  if (eventTypeFilter) {
    params.append("eventTypeFilter", eventTypeFilter);
  }

  if (fromTimestamp) {
    params.append("fromTimestamp", fromTimestamp.toString());
  }

  if (toTimestamp) {
    params.append("toTimestamp", toTimestamp.toString());
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getSupportInbox?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getAllGateways = (payload, token) => {
  const {
    gatewayId,
    search,
    entityId,
    status,
    connectionType,
    quality,
    sortKey,
    sortDir,
    pageNumber,
    pageSize,
    snapshotId,
    refresh,
  } = payload || {};

  const params = new URLSearchParams();

  if (gatewayId) {
    params.append("gatewayId", gatewayId);
  }

  if (search) {
    params.append("search", search);
  }

  if (entityId) {
    params.append("entityId", entityId);
  }

  if (status) {
    params.append("status", status);
  }

  if (connectionType) {
    params.append("connectionType", connectionType);
  }

  if (quality) {
    params.append("quality", quality);
  }

  if (sortKey) {
    params.append("sortKey", sortKey);
  }

  if (sortDir) {
    params.append("sortDir", sortDir);
  }

  if (pageNumber !== undefined) {
    params.append("pageNumber", pageNumber.toString());
  }

  if (pageSize !== undefined) {
    params.append("pageSize", pageSize.toString());
  }

  if (snapshotId) {
    params.append("snapshotId", snapshotId);
  }

  if (refresh) {
    params.append("refresh", "true");
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getAllGateways?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getGatewayUptime = (
  { windowKey, entityId, gatewayId, refresh } = {},
  token,
) => {
  const params = new URLSearchParams();

  if (windowKey) {
    params.append("window", windowKey);
  }

  if (entityId) {
    params.append("entityId", entityId);
  }

  if (gatewayId) {
    params.append("gatewayId", gatewayId);
  }

  if (refresh) {
    params.append("refresh", "true");
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getGatewayUptime?${params.toString()}`,
    withCredentials: true,
    timeout: 120000,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getAllUsers = (payload, token) => {
  const {
    search,
    entityId,
    activity,
    signIn,
    role,
    quality,
    sortKey,
    sortDir,
    pageNumber,
    pageSize,
    snapshotId,
    refresh,
  } = payload || {};

  const params = new URLSearchParams();

  if (search) {
    params.append("search", search);
  }

  if (entityId) {
    params.append("entityId", entityId);
  }

  if (activity) {
    params.append("activity", activity);
  }

  if (signIn) {
    params.append("signIn", signIn);
  }

  if (role) {
    params.append("role", role);
  }

  if (quality) {
    params.append("quality", quality);
  }

  if (sortKey) {
    params.append("sortKey", sortKey);
  }

  if (sortDir) {
    params.append("sortDir", sortDir);
  }

  if (pageNumber !== undefined) {
    params.append("pageNumber", pageNumber.toString());
  }

  if (pageSize !== undefined) {
    params.append("pageSize", pageSize.toString());
  }

  if (snapshotId) {
    params.append("snapshotId", snapshotId);
  }

  if (refresh) {
    params.append("refresh", "true");
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getAllUsers?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getAllSubjects = (payload, token) => {
  const { search, agencyFilterId, status, pageSize, continuationToken } =
    payload || {};

  const data = Object.fromEntries(
    Object.entries({
      search,
      agencyFilterId,
      status,
      pageSize,
      continuationToken,
    }).filter(([, value]) => value !== undefined && value !== null),
  );

  const config = {
    method: "POST",
    url: `${baseUrl}/getAllSubjects`,
    data,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

export const getAgencyHealthScores = (getEntityId, accessToken) => {
  const params = new URLSearchParams();

  if (getEntityId) {
    params.append("getEntityId", getEntityId);
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getAgencyHealthScores?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  };
  return axios(config);
};

export const getAgencyKpis = (getEntityId, accessToken) => {
  const params = new URLSearchParams();

  if (getEntityId) {
    params.append("getEntityId", getEntityId);
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getAgencyKpis?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  };
  return axios(config);
};

export const getAgencyReport = (getEntityId, accessToken, options = {}) => {
  const params = new URLSearchParams();

  if (getEntityId) {
    params.append("getEntityId", getEntityId);
  }

  if (options.force) {
    params.append("force", "true");
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getAgencyReport?${params.toString()}`,
    withCredentials: true,
    // A cold Chromium render is a 10-60s job and axios has NO default timeout, so an
    // in-flight render would otherwise leave the preview modal spinning forever. This
    // sits above the Function's own 90s internal render race.
    timeout: 120000,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  };
  return axios(config);
};

export const getAgencyJmsFeedHistory = (
  getEntityId,
  accessToken,
  options = {},
) => {
  const { pageSize, continuationToken } = options || {};
  const params = new URLSearchParams();

  if (getEntityId) {
    params.append("getEntityId", getEntityId);
  }

  if (pageSize) {
    params.append("pageSize", pageSize.toString());
  }

  if (continuationToken) {
    params.append("continuationToken", continuationToken);
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getAgencyJmsFeedHistory?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  };
  return axios(config);
};

const updateSupportItemStatus = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/updateSupportItemStatus`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const updateSubjectsElapsedTimestamp = (payload, token) => {
  payload.deviceType = "Web App";

  const config = {
    method: "POST",
    url: `${baseUrl}/updateSubjectsElapsedTimestamp`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getEntityUsersAppVersionsByPagination = (
  entityId,
  pageSize,
  pageNumber,
  type,
  token,
) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/getEntityUsersAppVersionsByPagination?getEntityId=${entityId}&pageSize=${pageSize}&pageNumber=${pageNumber}&type=${type}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getEntityUsersFwVersionsByPagination = (
  entityId,
  pageSize,
  pageNumber,
  token,
) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/getEntityUsersFwVersionsByPagination?getEntityId=${entityId}&pageSize=${pageSize}&pageNumber=${pageNumber}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const startMonitoringSession = (payload, token) => {
  payload.deviceType = "Desktop App";

  const config = {
    method: "POST",
    url: `${baseUrl}/startMonitoringSession`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const getCurrentAppBuild = () => {
  const config = {
    method: "GET",
    url: `${baseUrl}/getCurrentAppBuild`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};

const createAcknowledgeSystemUse = () => {
  const config = {
    method: "POST",
    url: `${baseUrl}/createAcknowledgeSystemUse`,
    // data: payload,
    timeout: 15000,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};

const updateSystemUseNotificationPreference = (payload) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/updateSystemUseNotificationPreference`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};

const getJMSLastUpdated = (entityId) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/getJMSLastUpdated?getEntityId=${entityId}`,

    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};

const getIsUserBlocked = (entityId, unblockUser) => {
  const config = {
    method: "GET",
    url: `${baseUrl}/getIsUserBlocked?getEntityId=${entityId}&unblockUser=${unblockUser}`,

    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};

const unblockUser = (payload) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/unblockUser`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};

const negotiateV2 = () => {
  const config = {
    method: "POST",
    url: `${baseUrl}/negotiateV2`,

    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};

const createSupportTicket = (payload) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/createSupportTicket`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};

const notifyDownload = (payload) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/notifyDownload`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};

const getCameraData = (subjectId, pageSize, continuationToken, getEntityId) => {
  const params = new URLSearchParams();

  params.append("subjectId", subjectId);
  params.append("pageSize", pageSize.toString());

  if (continuationToken) {
    params.append("continuationToken", continuationToken);
  }

  if (getEntityId) {
    params.append("getEntityId", getEntityId);
  }

  const config = {
    method: "GET",
    url: `${baseUrl}/getCameraData?${params.toString()}`,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axios(config);
};

const createReportsDownload = (payload, token) => {
  const config = {
    method: "POST",
    url: `${baseUrl}/createReportsDownload`,
    data: payload,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};

const userService = {
  createReportsDownload,
  getCameraData,
  notifyDownload,
  createSupportTicket,
  negotiateV2,
  unblockUser,
  getIsUserBlocked,
  getJMSLastUpdated,
  createAcknowledgeSystemUse,
  updateSystemUseNotificationPreference,
  getCurrentAppBuild,
  startMonitoringSession,
  getEntityUsersFwVersionsByPagination,
  getEntityUsersAppVersionsByPagination,
  updateSubjectsElapsedTimestamp,
  getUserActionsHistoryV2,
  getSupportInbox,
  getAllGateways,
  getGatewayUptime,
  getAllUsers,
  getAllSubjects,
  getAgencyHealthScores,
  getAgencyKpis,
  getAgencyReport,
  getAgencyJmsFeedHistory,
  updateSupportItemStatus,
  updateEntityInformation,
  getEntityCallbacks,
  updateEntityCallbacks,
  getOptiGuardAlertSubscriptions,
  updateOptiGuardAlertSubscription,
  updateUserInformation,
  deleteRouter,
  deleteSubject,
  getEntityActiveSubjectsBySearchPagination,
  getEntityActiveSubjectsByPagination,
  editSubject,
  createSubject,
  createCellSubject,
  createGeneralFeedback,
  createAcknowledgeDeviceNotification,
  removeSubjectsFromAlertGroup,
  addSubjectsToAlertGroup,
  deleteAlertGroup,
  createAlertGroup,
  transferSubjects,
  getSuperAnalyticsData,
  createFeedback,
  getAnalyticsData,
  getDataForDownloadPdfSasLink,
  getTrainingMaterials,
  getTrainingMaterialSasLink,
  updateTrainingProgress,
  getTrainingUploadSasLink,
  createTrainingMaterial,
  updateTrainingMaterial,
  deleteTrainingMaterial,
  uploadFileToTrainingSas,
  reportGeneratorHTTP,
  createInstantCriticalAlert,
  getMinutelyWellnessDataByPaginationV2,
  getHourlyWellnessDataByPaginationV2,
  getDailyWellnessDataByPaginationV2,
  getDailyWellnessData,
  getHourlyWellnessData,
  logWellnessRecord,
  logSignalRDisconnect,
  deleteUser,
  updateEntityLogo,
  createFakeUser,
  getUsersData,
  getCheckedOutSensors,
  getCheckedOutSensorsBySearch,
  changeGatewayLocation,
  changeUsersTitle,
  joinSignalRGroupsV2,
  removeSignalRGroupsV2,
  publicDataProcessor,
  logUsersAlertAction,
  logSubjectNote,
  getSubjectsInteractionHistoryByPagination,
  addUsersNfcTools,
  removeUsersNfcTools,
  registerRouter,
  getEntitysInformation,
  createEntity,
  checkDeviceData,
  getEntitiesByPagination,
  getEntitiesBySearchPagination,
  getEntitiesV2,
  getPdfSasLink,
  getSubjectsProfile,
  getEntitySubjectsByPagination,
  getEntitySubjectsBySearchPagination,
  getActiveMonitoringSessionsBySubscription,
  updateUserPreference,
  getAlertHistoryV2,
  pinSubject,
  unpinSubject,
  changeUsersRole,
  inviteUser,
  getEntityUsersBySearch,
  getEntityUsers,
  getEntityUsersV2,
  getEntityUsersBySearchV2,
  getArchiveData,
  getSubjectBatteryHistory,
  getDeviceSessionHistory,
  resetCriticalAlert,
  stopMonitoringSession,
  getImageSasToken,
  getUserInfo,
  getActiveMonitoringSessions,
  getActiveMonitoringSessionBySubjectId,
  negotiate,
  joinSignalRGroups,
  removeSignalRGroups,
  getEntityRouters,
};
export default userService;
